<template>
  <b-modal ref="driver-card-modal" @ok="driverCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.drivers.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.firstName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="firstName"
          :state="isFirstNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.lastName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="lastName"
          :state="isLastNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.patronymic"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="patronymic"
          :state="isPatronymicValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.note"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="note"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.cardId"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="cardId"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.isActive"
        label-for="input-horizontal"
      >
        <b-form-checkbox
            v-model="isActive"
            :value="1"
            :unchecked-value="0"
          >
          </b-form-checkbox>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.driversCompanyId"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="driversCompanyId"
          :options="driverCompaniesOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.technicalDeviceId"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="technicalDeviceId"
          :options="technicalDevicesOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="driver.executor"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateDriverPage",
  props: {
    driver: Object,
    technicalDevices: Array,
    driverCompanies: Array,
    globalDriverCompanies: Array,
  },
  components: {},
  data() {
    return {
      driverCompaniesOptions: [],
      technicalDevicesOptions: [],

      firstName: null,
      lastName: null,
      patronymic: null,
      note: null,
      cardId: null,
      isActive: null,
      driversCompanyId: null,
      technicalDeviceId: null,
     
      isFirstNameValid: null,
      isLastNameValid: null,
      isPatronymicValid: null,

      created: null,
      updated: null
    };
  },
  methods: {
    async open() {
      this.firstName = this.driver.firstName;
      this.lastName = this.driver.lastName;
      this.patronymic = this.driver.patronymic;
      this.note = this.driver.note;
      this.cardId = this.driver.cardId;
      this.isActive = this.driver.isActive;

      this.isFirstNameValid = null;
      this.isLastNameValid = null;
      this.isPatronymicValid = null;
      this.driverCompaniesOptions = [];
      
      for (let i = 0; i < this.driverCompanies.length; i++) {
        if (this.driverCompanies[i].clientId == this.driver.clientId) {
          this.driverCompaniesOptions.push({
            value: `${this.driverCompanies[i].id}-local`,
            text: this.driverCompanies[i].companyName,
          });

          if (this.driverCompanies[i].companyId == this.driver.driversCompanyId) {
            this.driversCompanyId = `${this.driverCompanies[i].id}-local`;
          }
        }
      }

      for (let i = 0; i < this.globalDriverCompanies.length; i++) {
        this.driverCompaniesOptions.push({
            value: `${this.globalDriverCompanies[i].id}-global`,
            text: this.globalDriverCompanies[i].unit,
          });

          if (this.globalDriverCompanies[i].id == this.driver.globalCompanyId) {
            this.driversCompanyId = `${this.globalDriverCompanies[i].id}-global`;
          }
      }
      
      this.technicalDevicesOptions = [];

      for (let i = 0; i < this.technicalDevices.length; i++) {
        if (this.technicalDevices[i].clientId == this.driver.clientId) {
          this.technicalDevicesOptions.push({
            value: this.technicalDevices[i].id,
            text: this.technicalDevices[i].nameTechnicalDevice,
          });

          if (this.technicalDevices[i].technicalDeviceId == this.driver.technicalDeviceId) {
            this.technicalDeviceId = this.technicalDevices[i].id;
          }
        }
      }

      this.created = utilsService.formatDateTime(new Date(this.driver.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.driver.updated * 1000), utilsService.DATE_TIME_FORMAT);

      this.$refs["driver-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.firstName) {
        this.isFirstNameValid = false;
        isValid = false;
      } else {
        this.isFirstNameValid = null;
      }

      if (!this.lastName) {
        this.isLastNameValid = false;
        isValid = false;
      } else {
        this.isLastNameValid = null;
      }

      if (!this.patronymic) {
        this.isPatronymicValid = false;
        isValid = false;
      } else {
        this.isPatronymicValid = null;
      }

      return isValid;
    },
    async driverCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      this.driver.firstName = this.firstName;
      this.driver.lastName = this.lastName;
      this.driver.patronymic = this.patronymic;
      this.driver.note = this.note;
      this.driver.cardId = this.cardId;
      this.driver.isActive = this.isActive;
      
      if (this.driversCompanyId.includes('-local')) {
        const driversCompanyId = parseInt(this.driversCompanyId.replace('-local', ''));
        const driverCompany = this.driverCompanies.find(x => x.id == driversCompanyId);

        this.driver.driversCompanyId = driverCompany.companyId;
        this.driver.globalCompanyId = 0;
      } else {
        const driversCompanyId = parseInt(this.driversCompanyId.replace('-global', ''));
        const globalDriverCompany = this.globalDriverCompanies.find(x => x.id == driversCompanyId);
        this.driver.globalCompanyId = globalDriverCompany.id;
        this.driver.driversCompanyId = 0;
      }
      
      const technicalDevice = this.technicalDevices.find(x => x.id == this.technicalDeviceId);
      this.driver.technicalDeviceId = technicalDevice.technicalDeviceId;
      
      const updateDriverResponse = await azkService.updateDriver(this.driver);

      if (
        updateDriverResponse.isSuccess &&
        updateDriverResponse.data &&
        updateDriverResponse.data.countInsertedRows == 1
      ) {
        this.$emit("driverUpdatedSuccessEvent", this.driver);
      } else {
        this.$emit("driverUpdatedFailEvent");
      }
    },
  },
};
</script>
